"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _dec, _dec2, _dec3, _class, _temp;

require("source-map-support/register");

var _tsyringe = require("tsyringe");

var injectable = _tsyringe.injectable;

var _types = require("./Providers/types");

var Provider = _types.Provider;

var _LoggerConfig = require("./LoggerConfig");

var LoggerConfig = _interopRequireDefault(_LoggerConfig)["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Logger = (_dec = injectable(), _dec2 = Reflect.metadata("design:type", Function), _dec3 = Reflect.metadata("design:paramtypes", [typeof Provider === "undefined" ? Object : Provider, typeof LoggerConfig === "undefined" ? Object : LoggerConfig]), _dec(_class = _dec2(_class = _dec3(_class = (_temp = /*#__PURE__*/function () {
  function Logger(provider) {
    var _this = this;

    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      debug: false
    };

    _classCallCheck(this, Logger);

    this.provider = void 0;
    this.config = void 0;

    this.log = function (message) {
      _this.debug(message);
    };

    this.logException = function (exception) {
      _this.debug(exception);

      _this.provider.logException(exception);
    };

    this.close = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.provider.close(_this.getCloseTimeout());

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    this.provider = provider;
    this.config = config;
  }

  _createClass(Logger, [{
    key: "getCloseTimeout",
    value: function getCloseTimeout() {
      if (typeof this.config.timeout === 'number') {
        return this.config.timeout;
      }

      return 3000;
    }
  }, {
    key: "debug",
    value: function debug(data) {
      if (this.config.debug) console.debug(data);
    }
  }]);

  return Logger;
}(), _temp)) || _class) || _class) || _class);
exports["default"] = Logger;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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